import { PriceType } from '@/app/shared/types/common';

export interface Balance {
  tonBalance: string;
  tonTotalIncome: string;
  cookieBalance: string;
}

export enum BalanceTagType {
  BALANCE = 'Balance',
  BALANCE_HISTORY = 'BalanceHistory',
}

export interface BalanceHistoryRequest {
  type?: PriceType;
}

export interface BalanceHistoryRow {
  id: string;
  amount: number;
  balanceType: PriceType;
  description?: string;
  externalId?: string;
  metadata?: string;
  source: string;
  createdAt: number;
  updatedAt: number;
}
